import { useApolloClient } from '@apollo/react-hooks';
import { useAccount, useLogin } from '@bnnvara/accounts';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';

import { FetchAllUserLikes } from '../api/queries/me/likes.gql';
import withApolloClient from '../hocs/withApolloClient';

const LikesContext = React.createContext({
  addToAllUserLikes: () => null,
  allUserLikes: [],
  getLikeObject: () => null,
});

const NAME = 'name';
const INTERACTIONID = 'interactionId';

export const LikesContextProvider = withApolloClient(({ children }) => {
  const apolloClient = useApolloClient();
  const { isLoggedIn } = useLogin();
  const {
    profile: { UID },
  } = useAccount();
  const [allUserLikes, setAllUserLikes] = useState([]);

  useEffect(() => {
    const fetchAndSetLikes = async () => {
      const { data } = await apolloClient.query({
        query: FetchAllUserLikes,
        variables: {
          userId: UID,
        },
        fetchPolicy: 'network-only',
      });

      const likes = data.me.likes.map((like) => ({
        [NAME]: like.name,
        [INTERACTIONID]: like.interactionId,
      }));

      setAllUserLikes(likes);
    };
    if (isLoggedIn) {
      fetchAndSetLikes();
    }

    setAllUserLikes([]);
  }, [apolloClient, isLoggedIn, UID]);

  const addToAllUserLikes = (id, type) => {
    setAllUserLikes((prevLikes) => [
      ...prevLikes,
      { [NAME]: type, [INTERACTIONID]: id },
    ]);
  };

  const getLikeObject = (id, userId, type) => {
    const like = () =>
      allUserLikes
        .filter((usersLike) => usersLike[NAME] === type)
        .find((usersLike) => usersLike[INTERACTIONID] === id);

    return !!like();
  };

  return (
    <LikesContext.Provider
      value={{ getLikeObject, allUserLikes, addToAllUserLikes }}
    >
      {children}
    </LikesContext.Provider>
  );
});

LikesContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const useLikes = () => {
  const { addToAllUserLikes, allUserLikes, getLikeObject } = useContext(
    LikesContext
  );

  return { addToAllUserLikes, allUserLikes, getLikeObject };
};

export default useLikes;
